
import React from 'react';
const Icon = (props: React.SVGProps<SVGSVGElement>) =>
(
  <svg width="6" height="5" viewBox="0 0 6 5" fill="none" xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path d="M5 3.3335L3 1.3335L1 3.3335" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export default Icon
